module.exports = __webpack_public_path__ + "media/components/dashboard/icons/time-8efca042df3aef4e0c55a827cfae8f65.svg";